import { ReactNode, FC } from 'react';

export type WrapperComp = FC<{ children: ReactNode }>;

export const DraggableIdSeparator = '::';
